import React, {Component} from "react";
import {connect} from "react-redux";
import {Menu} from "antd";
import {Link} from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";

import Auxiliary from "util/Auxiliary";
import UserProfile from "./UserProfile";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";

const SubMenu = Menu.SubMenu;

class SidebarContentMayor extends Component {
  constructor(props) {
    super(props);
  }

  getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };

  render() {
    const {themeType, navStyle, pathname, history} = this.props;
    const selectedKeys = pathname.substr(1);
    const defaultOpenKeys = selectedKeys.split('/')[1];
    return (
      <Auxiliary>
        <SidebarLogo/>
        <div className="gx-sidebar-content">
          <div className={`gx-sidebar-notifications ${this.getNoHeaderClass(navStyle)}`}>
            <UserProfile history={history} userName={this.props.user.name} image={this.props.user.image}/>
          </div>
          <CustomScrollbars className="gx-layout-sider-scrollbar">
            <Menu
              defaultOpenKeys={[defaultOpenKeys]}
              selectedKeys={[selectedKeys]}
              theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
              mode="inline">

              <Menu.Item key="mayorDashboard">
                <Link to="/mayorDashboard">
                  <i className="icon icon-widgets"/>
                  <IntlMessages id="sidebar.home"/></Link>
              </Menu.Item>

              <SubMenu key="products" className={this.getNavStyleSubMenuClass(navStyle)}
                      title={<span> <i className="icon icon-product-list"/>
                      <IntlMessages id="sidebar.products"/></span>}>

                <Menu.Item key="mayorDashboard/productsList">
                  <Link to="/mayorDashboard/productsList">
                    <i className="icon icon-plain-list-divider"/>
                    <IntlMessages id="sidebar.productsList"/></Link>
                </Menu.Item>

                <Menu.Item key="mayorDashboard/addProduct">
                  <Link to="/mayorDashboard/addProduct">
                    <i className="icon icon-add-circle"/>
                    <IntlMessages id="sidebar.addProduct"/></Link>
                </Menu.Item>

                {/* <Menu.Item key="mayorDashboard/editProducts">
                  <Link to="/mayorDashboard/editProducts">
                    <i className="icon icon-feedback"/>
                    <IntlMessages id="sidebar.editProducts"/></Link>
                </Menu.Item> */}

              </SubMenu>

              <SubMenu key="affiliates" className={this.getNavStyleSubMenuClass(navStyle)}
                      title={<span> <i className="icon icon-auth-screen"/>
                      <IntlMessages id="sidebar.clientAffiliates"/></span>}>

                <Menu.Item key="mayorDashboard/clientAffiliatesList">
                  <Link to="/mayorDashboard/clientAffiliatesList">
                    <i className="icon icon-plain-list-divider"/>
                    <IntlMessages id="sidebar.clientAffiliatesList"/></Link>
                </Menu.Item>

                <Menu.Item key="mayorDashboard/clientAffiliatesRequest">
                  <Link to="/mayorDashboard/clientAffiliatesRequest">
                    <i className="icon icon-inbox"/>
                    <IntlMessages id="sidebar.affiliatesRequest"/></Link>
                </Menu.Item>

                <Menu.Item key="mayorDashboard/clientsInvitations">
                  <Link to="/mayorDashboard/clientsInvitations">
                    <i className="icon icon-feedback"/>
                    <IntlMessages id="sidebar.editAfiliates"/></Link>
                </Menu.Item>

              </SubMenu>
              
              <SubMenu key="orders" className={this.getNavStyleSubMenuClass(navStyle)}
                      title={<span> <i className="icon icon-orders"/>
                      <IntlMessages id="sidebar.orders"/></span>}>           
                           
                <Menu.Item key="mayorDashboard/ordersList">
                  <Link to="/mayorDashboard/ordersList">
                    <i className="icon icon-plain-list-divider"/>
                    <IntlMessages id="sidebar.ordersList"/></Link>
                </Menu.Item>

                <Menu.Item key="mayorDashboard/ordersComplete">
                  <Link to="/mayorDashboard/ordersComplete">
                    <i className="icon icon-check-circle-o"/>
                    <IntlMessages id="sidebar.ordersComplete"/></Link>
                </Menu.Item>

                <Menu.Item key="mayorDashboard/ordersWaiting">
                  <Link to="/mayorDashboard/ordersWaiting">
                    <i className="icon icon-circle-o"/>
                    <IntlMessages id="sidebar.ordersWaiting"/></Link>
                </Menu.Item>

                <Menu.Item key="mayorDashboard/ordersCancelled">
                  <Link to="/mayorDashboard/ordersCancelled">
                    <i className="icon icon-close-circle"/>
                    <IntlMessages id="sidebar.ordersCancelled"/></Link>
                </Menu.Item>

                {/* <Menu.Item key="mayorDashboard/ordersEdit">
                  <Link to="/mayorDashboard/ordersEdit">
                    <i className="icon icon-feedback"/>
                    <IntlMessages id="sidebar.ordersEdit"/></Link>
                </Menu.Item> */}

              </SubMenu>

              <SubMenu key="invoices" className={this.getNavStyleSubMenuClass(navStyle)}
                      title={<span> <i className="icon icon-listing-dbrd"/>
                      <IntlMessages id="sidebar.invoices"/></span>}>

                <Menu.Item key="mayorDashboard/invoices">
                  <Link to="/mayorDashboard/invoices">
                    <i className="icon icon-listing-dbrd"/>
                    <IntlMessages id="sidebar.invoicesList"/></Link>
                </Menu.Item>

              </SubMenu>

            </Menu>
          </CustomScrollbars>
        </div>
      </Auxiliary>
    );
  }
}

SidebarContentMayor.propTypes = {};
const mapStateToProps = ({settings, user, routing}) => {
  const {navStyle, themeType, locale, pathname} = settings;
  return {navStyle, themeType, locale, pathname, ...user, routing}
};
export default connect(mapStateToProps, {})(SidebarContentMayor);

